
import { supabase } from '@/integrations/supabase/client';

export const rewardTwitterShare = async (walletAddress: string): Promise<boolean> => {
  try {
    console.log('Attempting to reward Twitter share for wallet:', walletAddress);
    
    // First check if already rewarded to avoid unnecessary calls
    const { data: currentUser, error: fetchError } = await supabase
      .from('initiated_bros')
      .select('twitter_shared, bro_score')
      .eq('wallet_address', walletAddress.toLowerCase())
      .single();

    if (fetchError) {
      console.error('Error fetching user data:', fetchError);
      return false;
    }

    if (currentUser?.twitter_shared) {
      console.log('Twitter share already rewarded for this wallet');
      return false;
    }

    // Call the RPC function to reward Twitter share
    const { data: result, error: rpcError } = await supabase.rpc('reward_twitter_share', {
      wallet_address_param: walletAddress.toLowerCase()
    });

    if (rpcError) {
      console.error('Error calling reward_twitter_share RPC:', rpcError);
      return false;
    }

    console.log('Twitter share reward result:', result);
    return result === true;
  } catch (error) {
    console.error('Error in rewardTwitterShare:', error);
    return false;
  }
};

export const rewardTelegramVerify = async (walletAddress: string): Promise<boolean> => {
  try {
    console.log('Attempting to reward Telegram verification for wallet:', walletAddress);
    
    // First check if already rewarded to avoid unnecessary calls
    const { data: currentUser, error: fetchError } = await supabase
      .from('initiated_bros')
      .select('telegram_verified, bro_score')
      .eq('wallet_address', walletAddress.toLowerCase())
      .single();

    if (fetchError) {
      console.error('Error fetching user data:', fetchError);
      return false;
    }

    if (currentUser?.telegram_verified) {
      console.log('Telegram verification already rewarded for this wallet');
      return false;
    }

    // Call the RPC function to reward Telegram verification
    const { data: result, error: rpcError } = await supabase.rpc('reward_telegram_verify', {
      wallet_address_param: walletAddress.toLowerCase()
    });

    if (rpcError) {
      console.error('Error calling reward_telegram_verify RPC:', rpcError);
      return false;
    }

    console.log('Telegram verification reward result:', result);
    return result === true;
  } catch (error) {
    console.error('Error in rewardTelegramVerify:', error);
    return false;
  }
};

// Update the URL generation for Twitter share
export const generateTwitterShareUrl = (brocode: string): string => {
  const tweetText = `I just joined the BroMENtum brotherhood! 💪 My BroCode: ${brocode} 🔥

Join the movement at https://bromentum.xyz/brotocol

#BroMENtum #Brotherhood #Crypto @BroMENtum_club`;

  return `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`;
};
